module.exports = __webpack_public_path__ + "media/images/solutions-analytics-supporting-1-1e7872bd79b04b13455f759065e175fb.svg";